/* eslint-disable @typescript-eslint/no-floating-promises */
import React from 'react';
import { styled, Button as MuiButton } from '@mui/material';
import clsx from 'clsx';
import { getHomeButtonStyle, generateHomeButtonClassnames } from './style';
import { buttonClasses } from '../style';
import { filterOtherNativeProps } from '../util';
const HomeButtonBase = React.forwardRef((props, ref) => {
    const { children, onClick, className, autoFocus, sx, classes, fullWidth, htmlType, ...restProps } = props;
    const restNativeProps = filterOtherNativeProps(restProps);
    return (React.createElement(MuiButton, { ref: ref, disableRipple: true, className: className, onClick: onClick, autoFocus: autoFocus, classes: {
            startIcon: buttonClasses.startIcon,
            endIcon: buttonClasses.endIcon,
            focusVisible: buttonClasses.focusVisible,
        }, sx: sx, fullWidth: fullWidth, type: htmlType, ...restNativeProps }, children));
});
const StyledHomeButton = styled(HomeButtonBase)((props) => {
    const { theme } = props;
    return getHomeButtonStyle(theme, props);
});
const RefHomeButton = React.forwardRef((props, ref) => (React.createElement(StyledHomeButton, { ...props, ref: ref })));
const HomeButton = React.forwardRef((props, ref) => {
    const { children, onClick, className, type, size, disabled, autoFocus, sx, variant, fullWidth, ...restProps } = props;
    return (React.createElement(RefHomeButton, { ref: ref, className: clsx(generateHomeButtonClassnames(), className), onClick: onClick, size: size, type: type, disabled: disabled, autoFocus: autoFocus, sx: sx, fullWidth: fullWidth, ...restProps }, children));
});
export { HomeButton };
